module.exports = __webpack_public_path__ + "img/three3Red.58094f4c.jpg";